export const STORE_CONSTANTS = {
    LOGIN_SUCCESS   :   "LOGIN_SUCCESS",
    LOGIN_FAILED    :   "LOGIN_FAILED",
    LOGOUT_SUCCESS  :   "LOGOUT_SUCCESS",
    LOGIN_INFO      :   "LOGIN_INFO"
};
